import React from 'react';

export default ({ title, content }) => (
	<div className="accordion" tabIndex="0">
		<input type="checkbox" name="accordion-demo" id="accordion" tabIndex="-1" />
		<label className="header" htmlFor="accordion">
		<span className="label">{title}</span>

		<span aria-label="Control" class="icon-accordion">
          
		  <span class="icon " 
				style={{"WebkitMaskImage": "url(https://static.tui.com/assets/v2/icons/tui-light/chevron-down.svg)", "maskImage": "url(https://static.tui.com/assets/v2/icons/tui-light/chevron-down.svg)", "color":"currentColor"}}>
		  </span>
			  </span>
		</label>
		<section className="body">
			<div className="content">
				{content}
			</div>
		</section>
	</div>
)